import React from 'react';
import './Banner.css'

const Banner = () => {
    return (
        <div className="banner-bg text-light">
            <div className=" header-content">
                <h1 style={{ fontSize: '60px' }}>TRAVEL BEAUTIFUL BANGLADESH</h1>
                <p>TRAVELING IS THE BEST GIFT GIVEN BY NATURE TO US. TRAVEL YOUR COUNTRY AS WELL AS TRAVEL WHOLE WORLD.</p>
            </div>
        </div>
    );
};

export default Banner;